// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"07fce7a4446b521af9f3","682":"b6cbb6cf714a68c176d2","883":"c13d28bf06d2d24f8c62"}[chunkId] + ".js";
};